import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { AvailabilityData, LocationDetails, UserTableData } from '../../../components/context/availabilityRedirection';
import {
    GET_LOCATION_FAILURE,
    GET_LOCATION_REQUEST,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    GET_UNIT_FAILURE,
    GET_UNIT_SUCCESS,
    GET_UNIT_REQUEST,
    CREATE_APPOINTMENT_FAILURE,
    CREATE_APPOINTMENT_REQUEST,
    CREATE_APPOINTMENT_SUCCESS,
    CLEAR_APPOINTMENT,
    RESET_CREATE_VISITOR_ERROR,
} from '../constants/createAppoinment.constants';
import toast from 'react-hot-toast';

// Get Location Request
const getLocationRequest = () => {
    return {
        type: GET_LOCATION_REQUEST,
    };
};

const getLocationSuccess = (locations: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_SUCCESS,
        payload: locations,
    };
};

const getLocationFailure = (locationError: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_FAILURE,
        payload: locationError,
    };
};

const getLocationByIdRequest = () => {
    return {
        type: GET_LOCATION_BY_ID_REQUEST,
    };
};

const getLocationByIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_BY_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationByIdFailure = (locationByIdError: string) => {
    return {
        type: GET_LOCATION_BY_ID_FAILURE,
        payload: locationByIdError,
    };
};

const getUnitRequest = () => {
    return {
        type: GET_UNIT_REQUEST,
    };
};

const getUnitSuccess = (locations: AnyIfEmpty<object>) => {
    return {
        type: GET_UNIT_SUCCESS,
        payload: locations,
    };
};

const getUnitFailure = (locationError: AnyIfEmpty<object>) => {
    return {
        type: GET_UNIT_FAILURE,
        payload: locationError,
    };
};

const createAppoinmentRequest = () => {
    return {
        type: CREATE_APPOINTMENT_REQUEST,
    };
};

const createAppoinmentSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: CREATE_APPOINTMENT_SUCCESS,
        payload: data,
    };
};

const createAppoinmentFailure = (error: AnyIfEmpty<object>) => {
    return {
        type: CREATE_APPOINTMENT_FAILURE,
        payload: error,
    };
};

const clearAppointmentData = () => {
    return {
        type: CLEAR_APPOINTMENT,
    };
};

export const getLocation = () => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationRequest());
        return await axios
            .get('/locations')
            .then((response) => dispatch(getLocationSuccess(response.data)))
            .catch((error) => dispatch(getLocationFailure(error)));
    };
};

export const getLocationById = (id: string | undefined | null, params?: {
    search?: string;
    statusFilter?: 'available' | 'unavailable' | 'all';
    page?: number;
    limit?: number;
}) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationByIdRequest());
        return axios
            .get(`/admin/units/list/${id}`, {
                params: {
                    ...(params?.search && { search: params.search }),
                    ...(params?.statusFilter && { statusFilter: params.statusFilter }),
                    ...(params?.page && { page: params.page }),
                    ...(params?.limit && { limit: params.limit }),
                },
            })
            .then((response) => {
                dispatch(getLocationByIdSuccess(response.data?.data))
            })
            .catch((error) => {
                dispatch(getLocationByIdFailure(error.message));
            });
    };
};

export const getUnit = (id: string | undefined | null) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getUnitRequest());
        return axios
            .get(`/units/${id}`)
            .then((response) => dispatch(getUnitSuccess(response.data.units)))
            .catch((error) => dispatch(getUnitFailure(error)));
    };
};

export const createVisitorAppointment = (
    userId: string | undefined,
    visitorObj: AnyIfEmpty<object>,
    setStep?: Dispatch<SetStateAction<number>>,
    setAvailabilityData?: Dispatch<SetStateAction<AvailabilityData>>,
    setData?: Dispatch<SetStateAction<never[]>>,
    setLocationDetails?: Dispatch<SetStateAction<LocationDetails>>,
    setSelectedUserTableData?: Dispatch<SetStateAction<UserTableData>>,
    setUserId?: Dispatch<SetStateAction<string>>,
) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(createAppoinmentRequest());
        return await axios
            .post(`appointments/admin-user-appointment/${userId}`, visitorObj)
            .then((response) => {
                if (response.data.statusCode === 201) {
                    dispatch(createAppoinmentSuccess(response.data));
                    setStep?.(1);
                    setAvailabilityData?.({
                        locationId: '',
                        locationName: '',
                        selectedDate: '',
                        slotRange: '',
                        unitId: '',
                        unitName: '',
                        lockerNumber: 0,
                    });
                    setSelectedUserTableData?.({
                        bedrooms: '',
                        companyName: '',
                        contact: '',
                        countryCode: '',
                        date: '',
                        email: '',
                        locationName: '',
                        name: '',
                    });
                    setLocationDetails?.({
                        city: '',
                        description: '',
                        id: '',
                        images: [],
                        name: '',
                        provisioningId: '',
                        state: '',
                        street1: '',
                        street2: '',
                        streetNumber: '',
                        timeZone: '',
                        zip: '',
                        lockerName: ''
                    });
                    setUserId?.('');
                    setData?.([]);
                } else {
                    dispatch(createAppoinmentFailure(response.data.message));
                }
            })
            .catch((error) => {
                dispatch(createAppoinmentFailure(error?.response?.data?.message))
            });
    };
};

export const clearAppointments = () => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(clearAppointmentData());
    };
};

export const resetCreateVisitorError = () => {
    return {
        type: RESET_CREATE_VISITOR_ERROR,
    };
}